RivalIQ.apps.Discovery.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const TableView = RivalIQ.apps.Dashboard.widgets.MetricTable.mixin({
        ui: _.defaults({
            filterContainer: '.filter-container',
            tooltips: '[data-toggle="tooltip"]'
        }, RivalIQ.apps.Dashboard.widgets.MetricTable.prototype.ui),

        mixins: {
            normalizeHeights: RivalIQ.apps.Dashboard.mixins.NormalizeHeights,
            LoadDataWithBuffering: RivalIQ.apps.Dashboard.mixins.LoadDataWithBuffering
        },

        className: function () {
            const me = this;
            return [
                'chart table-chart',
                me.getProp('trailingBar') ? 'trailing-bar' : '',
                me.dashboardModel.getSize(),
                me.dashboardModel.isExporting() ? 'x-table-container' : 'table-responsive table-responsive-overflow-x-override',
                'discovery-analysis-table'
            ].join(' ');
        },

        onRender: function () {
            const me = this;

            // normalizeHeights needs a flex-region to do it's work, this seemed
            // to be the least invasive way to get this div into the view for prototype
            // purposes.
            if (me.$el.find('.flex-region').length === 0) {
                me.$el.append('<div class="flex-region"></div>');
            }

            me.ui.tooltips.tooltip();

            if (_.includes(['mention', 'postAuthor'], _.head(RivalIQ.metric.getFreeDimensions(me.metric)))) {
                App.views.InfluencerPopover.addPopovers(me, me.ui.filterContainer, null, true);
            }
        },

        rowClassName: 'discovery-table-row',

        _loadData: function () {
            const me = this;

            me.metricsCollection = new me.metricsCollection.constructor(me.dashboardModel.unfilteredMetrics, {
                model: me.metricsCollection.model,
                comparator: me.metricsCollection.comparator
            });

            // we need to get the number of unique users here since we show/hide
            // columns if there was just a single unique user.
            const metric = RivalIQ.metric.build(me.getProps(), _.defaults({
                dimensions: ['channel'],
                property: 'unique_users'
            }, me.dashboardModel.baseMetric), {
                clobberDimensions: true
            });

            const metricDef = new RivalIQ.models.MetricDefinition(metric);

            const singleUserFetch = metricDef.fetch()
                .then(function (results) {
                    me.numUniqueUsers = results.getValue({
                        format: false
                    });
                });

            return $.when(singleUserFetch, RivalIQ.apps.Dashboard.widgets.MetricTable.prototype.loadData.call(me))
                .then(function () {
                    me.dashboardModel.metricsToOmit = me._determineColumnsToOmit();

                    me.collection = new me.collection.constructor(me.collection.reject(function (column) {
                        return me.dashboardModel.metricsToOmit[column.get('property')];
                    }));
                    me.metricsCollection = new me.metricsCollection.constructor(me.metricsCollection.reject(function (column) {
                        return me.dashboardModel.metricsToOmit[column.get('property')];
                    }));

                    me.sortColumns = App.utils.getColumnSortOrder(me.metricsCollection, me.getProp('orderBy'));
                });
        },

        _determineColumnsToOmit: function () {
            const me = this;

            let metricsToOmit = {};
            if (!me.getProp('instanceId')) {
                const onlyOneUser = (me.numUniqueUsers === 1);

                metricsToOmit = _.reduce(me.metrics, function (memo, metric) {


                    let shouldOmit = false;
                    if (metric.hideWhenSinglePeopleUsing && onlyOneUser) {
                        shouldOmit = true;
                    } else if (metric.showWhenSinglePeopleUsing && onlyOneUser) {
                        shouldOmit = false;
                    } else if (metric.focusOnly) {
                        shouldOmit = true;
                    }

                    if (shouldOmit) {
                        memo[metric.property] = true;
                    }

                    return memo;
                }, {});
            }

            return metricsToOmit;
        },

        onRowClick: function (data, e) {
            const me = this;

            const target = $(e.target);

            // need the parents selector as sometimes the target is the font-awesome icon.
            if (target.hasClass('x-view-posts') || target.parents('.x-view-posts').length > 0) {
                const filterName = `${_.head(RivalIQ.metric.getFreeDimensions(me.metric))}Filters`;
                const filterValue = data[0][0];
                const modalProps = me.getProps();
                modalProps[filterName] = (modalProps[filterName] || []).concat(filterValue);
                App.views.PostsModal.show(modalProps);
                e.preventDefault();
            } else if (target.hasClass('x-filter-results') || target.parents('.x-filter-results').length > 0) {
                App.utils.trackFilterLinkClick(target, me);
            }
        },

        getFetchAttributes: function () {
            const me = this;

            const metrics = new me.metricsCollection.constructor(me.metricsCollection.reject(function (column) {
                return _.get(me.dashboardModel, ['metricsToOmit', column.get('property')]);
            }));

            // it's possible that we're trying to order by a metric that we will end up redacting. In this case,
            // break ties with another metric we will end up showing.
            let orderBy = me.getProp('orderBy');
            const orderByMetric = metrics.at(_.isArray(orderBy) ? _.head(orderBy) : orderBy);
            if (orderByMetric && (orderByMetric.get('hideWhenSinglePeopleUsing') || orderByMetric.get('showWhenSinglePeopleUsing'))) {
                const otherMetric = metrics.find(function (metric, idx) {
                    if (idx === orderBy) {
                        return false;
                    }
                    return metric.get('hideWhenSinglePeopleUsing') || metric.get('showWhenSinglePeopleUsing');
                });
                if (otherMetric) {
                    orderBy = [orderBy, metrics.indexOf(otherMetric)];
                    // NOTE in the event we have an `otherMetric`, and thus a
                    // secondary sort, we need to update the props value as
                    // well so that the table will apply the sort, too (if we
                    // didn't only the server would honor the sort)
                    me.setProps({
                        orderBy: orderBy
                    }, {
                        silent: true
                    });
                }
            }
            me.sortColumns = App.utils.getColumnSortOrder(me.metricsCollection, orderBy);

            return {
                limit: Number(me.getProp('limit') || 0),
                sortOrder: Number(me.getProp('sortOrder') || 1),
                orderBy: App.utils.getOrderByString(me.sortColumns, metrics)
            };
        }
    });

    const DimensionAnalysisWidget = RivalIQ.apps.Dashboard.widgets.TableWidget.mixin({
        view: TableView,
        tableClassName: 'table-hover',
        neverFilter: true,
        footerView: RivalIQ.apps.Dashboard.views.PanelFooter,

        mixins: {
            exportHD: RivalIQ.apps.Dashboard.mixins.ExportHD
        },

        getFilename: App.utils.getExportFilename,
        getExportTitle: App.utils.exportTitle,
        getExportSubtitle: App.utils.exportSubtitle,
        getPptSubtitle: App.utils.pptSubtitle,

        buildMetricsCollection: function (showAllMetrics) {
            const me = this;

            let metricDefs = me.metrics;
            if (!showAllMetrics && !me.getProp('instanceId')) {
                metricDefs = _.reject(metricDefs, function (metricDef) {
                    // if showWhenSinglePeopleUsing, we need to request the metric and potentially
                    // filter it later
                    return metricDef.focusOnly && !metricDef.showWhenSinglePeopleUsing;
                });
            }

            me.unfilteredMetrics = RivalIQ.metric.build(me.metric, metricDefs);
            return new RivalIQ.collections.MetricDefinitions(me.unfilteredMetrics);
        },

        processProps: function (props) {
            const me = this;

            props = _.defaults(props, {
                limit: 5,
                orderBy: 1,
                sortOrder: 1, // descending
                showDescriptions: true
            });

            me.metric = RivalIQ.metric.build(props, _.clone(me.baseMetric));

            me.metricsCollection = me.buildMetricsCollection();

            const parentFn = RivalIQ.apps.Dashboard.widgets.TableWidget.prototype.processProps;
            return parentFn.apply(me, arguments);
        },

        csvExportProps: function () {
            const me = this;

            return {
                type: 'discoveryDataGenerator',
                metric: me.getExportMetricDefinitions(RivalIQ.enums.exportFormat.CSV),
                includeDimensionColumn: false
            };
        },

        getExportMetricDefinitions: function (format) {
            const me = this;

            const metricsCollection = me.buildMetricsCollection(format === RivalIQ.enums.exportFormat.CSV);
            const metrics = metricsCollection.invoke('serialize', format);

            const sortColumns = App.utils.getColumnSortOrder(metricsCollection, me.getProp('orderBy'));
            const orderBy = App.utils.getOrderByString(sortColumns, metricsCollection);

            return _.map(metrics, function (metric) {
                return _.extend(metric, {
                    orderBy: orderBy,
                    limit: -1
                });
            });
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.DISCOVERY_DIMENSION_ANALYSIS, DimensionAnalysisWidget);

});
